/**
 * Eine Regel für Passwörter an allen Stellen: Registrierung, Einrichtung, Einladung, Profil, Konto im Creator-Portal und
 * Zurücksetzen (SICHT-OEFFENTLICH-BETRIEB-07; vorher 8 Zeichen beim Anlegen und 10 beim Zurücksetzen, sodass ein beim
 * Registrieren erlaubtes Passwort beim Zurücksetzen abgelehnt wurde). Supabase Auth „Minimum password length“ steht auf
 * demselben Wert (docs/EINSPIELPLAN.md); die Obergrenze 72 ist die Grenze von bcrypt.
 */
export const MIN_PASSWORD_LENGTH = 10;
export const MAX_PASSWORD_LENGTH = 72;

/** Hinweis unter jedem Feld für ein neues Passwort. */
export function passwordHint(lang: "de" | "en" = "de"): string {
  return lang === "en" ? `At least ${MIN_PASSWORD_LENGTH} characters.` : `Mindestens ${MIN_PASSWORD_LENGTH} Zeichen.`;
}

/** Meldung, wenn das Passwort zu kurz oder zu lang ist; sonst null. */
export function passwordLengthProblem(password: string, lang: "de" | "en" = "de"): string | null {
  if (password.length < MIN_PASSWORD_LENGTH) {
    return lang === "en" ? `The password needs at least ${MIN_PASSWORD_LENGTH} characters.` : `Das Passwort braucht mindestens ${MIN_PASSWORD_LENGTH} Zeichen.`;
  }
  if (password.length > MAX_PASSWORD_LENGTH) {
    return lang === "en" ? `The password may have at most ${MAX_PASSWORD_LENGTH} characters.` : `Das Passwort darf höchstens ${MAX_PASSWORD_LENGTH} Zeichen haben.`;
  }
  return null;
}
